import { partial } from 'modules/utils'
import { toggleClass, on } from 'modules/dom'

const DEBUG_CLASS = 'is-debugging-layout'

export default (el) => {
  const activate = partial(toggleClass, DEBUG_CLASS, document.body)
  on('click', activate, el)
}
